import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const historyService = {
  getHistoryEntityId,
};

const { apiUrl, apiVer } = defineConfig.HISTORY_SERVICE;

function getApiPath(){
    const version = (apiVer !== null ? ("/" + apiVer) : "");
    return (apiUrl + version + "/history");
}

function getHistoryEntityId(entityName, id, searchFilters = {}) {
  const newFilters = Object.entries(searchFilters)
  .filter(([, value]) => value !== null && value !== undefined && value !== '')
  .map(([key, value]) => {
    const encodedValue = Array.isArray(value)
      ? encodeURIComponent(value.join(','))
      : encodeURIComponent(value);

    return `${key}=${encodedValue}`;
  })
  .join('&');

  const url = getApiPath() + "/all/" + entityName + "/" + id + (newFilters ? "?" + newFilters : "");

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}